import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './services/AuthContext';
import Header from './components/Header';
import Home from './pages/Home';
import AuthPage from './pages/AuthPage';
import DashboardView from './views/DashboardView';
import ComprehensiveIssueCertificate from './pages/ComprehensiveIssueCertificate';
import MyCertificates from './pages/MyCertificates';
import VerifyView from './views/VerifyView';
import StudentAccess from './pages/StudentAccess';
import CertificateDetails from './pages/CertificateDetails';
import ProtectedRoute from './components/ProtectedRoute';
import './styles/professional.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/login" element={<AuthPage />} />
              <Route path="/register" element={<AuthPage />} />
              <Route path="/verify" element={<VerifyView />} />
              <Route path="/verify/:id" element={<VerifyView />} />
              <Route path="/verify/hash/:hash" element={<VerifyView />} />
              <Route path="/student-access" element={<StudentAccess />} />
              <Route path="/certificate/:id" element={<CertificateDetails />} />

              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <DashboardView />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/issue" 
                element={
                  <ProtectedRoute roles={['ADMIN']}>
                    <ComprehensiveIssueCertificate />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/my-certificates" 
                element={
                  <ProtectedRoute roles={['ADMIN']}>
                    <MyCertificates />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </main>
          
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#fff',
                color: '#1a202c',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              },
              success: {
                iconTheme: {
                  primary: '#48bb78',
                  secondary: '#fff',
                },
              },
              error: {
                iconTheme: {
                  primary: '#e53e3e',
                  secondary: '#fff',
                },
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;